import script from "./ViewEvidenceModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ViewEvidenceModal.vue?vue&type=script&lang=ts&setup=true"

import "./ViewEvidenceModal.vue?vue&type=style&index=0&id=50864342&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50864342"]])

export default __exports__